import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {  DoubleArrow, YouTube } from "@material-ui/icons";
import { MuiAddCircle, MuiGrid, MuiTypography, MuiPaper, MuiButton, MuiDoubleArrow, MuiYouTube  } from "../../ui/MaterialUIComponents";
import { Link } from 'react-router-dom'
import theme from '../../../assests/theme'
import routes from '../../navigation/Routes'
const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2)
  },
  headerStyle: { background: theme.palette.primary.main, width: '100%', height: "auto", boxSizing: 'content-box', padding: "10px 0px" },
  footerStyle: { borderTop: '1px solid ' + theme.palette.grey.main, padding: 8 },
  headerTextStyle: { textTransform: 'none', font: "Bold 14px/16px Arial", color: '#fff' },
  circle: {
    width: "25px",
    height: "25px",
    background: "#d5ebfc",
    borderRadius: "100px",
    position: "relative"
  },
  h5: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    margin: "0",
    color: "#fff"
  },
  verticalLine: {
    width: "2px",
    height: "15px",
    background: "#2ecc71",
    marginLeft: "12px",
    marginTop: "4px"
  }
}));

export default function CreateNewSchoolStepsCardComponent(props) {
  const classes = useStyles();

  return (
    <MuiPaper style={{ margin: 10 }}>
      <MuiGrid
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{ background: theme.palette.primary.main, height: "50px" }}
      >
        <MuiGrid container justify="center"
          alignItems="center"
          className={classes.headerStyle}>
          <Link
            to={{
              pathname: routes.addSchool,
              state: {
                isCreateNewSchool: true
              }
            }}
            style={{ textDecoration: 'none' }}
          >
            <MuiButton >
              <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />
              <MuiTypography className={classes.headerTextStyle}>
              {props.i18n.dashBoard.createSchoolProfileButton}</MuiTypography>
          </MuiButton></Link>
        </MuiGrid>
      </MuiGrid>
      <MuiGrid className={classes.root}>
        <MuiGrid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <MuiGrid item xs={12}>
            <MuiTypography style={theme.typography.body}  >
            {props.i18n.dashBoard.createSchoolProfileDescription}
            </MuiTypography>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
            <MuiGrid item>
            <MuiTypography style={theme.typography.body}><b>1.</b></MuiTypography>
            </MuiGrid>
          <MuiGrid item xs={10}>
            <MuiTypography style={theme.typography.body}  align='left'>
            {props.i18n.dashBoard.createSchoolProfilePoint1}
            </MuiTypography>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <MuiGrid item>
            <MuiTypography style={theme.typography.body}><b>2.</b></MuiTypography>
          </MuiGrid>
          <MuiGrid item xs={10}>
            <MuiTypography style={theme.typography.body}  align='left'>
            {props.i18n.dashBoard.createSchoolProfilePoint2}
            </MuiTypography>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <MuiGrid item>
            <MuiTypography style={theme.typography.body}><b>3.</b></MuiTypography>
          </MuiGrid>
          <MuiGrid item xs={10}>
            <MuiTypography style={theme.typography.body}  align='left'>
            {props.i18n.dashBoard.createSchoolProfilePoint3}
            </MuiTypography>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <MuiGrid item>
            <MuiTypography style={theme.typography.body}><b>4.</b></MuiTypography>
          </MuiGrid>
          <MuiGrid item xs={10}>
            <MuiTypography style={theme.typography.body}  align='left'>
            {props.i18n.dashBoard.createSchoolProfilePoint4}
            </MuiTypography>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <MuiGrid item>
            <MuiTypography style={theme.typography.body}><b>5.</b></MuiTypography>
              </MuiGrid>
          <MuiGrid item xs={10}>
            <MuiTypography style={theme.typography.body}  align='left'>
            {props.i18n.dashBoard.createSchoolProfilePoint5}
            </MuiTypography>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <MuiGrid item>
            <MuiGrid >
              <MuiTypography style={theme.typography.body}><b>6.</b></MuiTypography>
            </MuiGrid>
          </MuiGrid>
          <MuiGrid item xs={10}>
            <MuiTypography style={theme.typography.body}  align='left'>
            {props.i18n.dashBoard.createSchoolProfilePoint6}
            </MuiTypography>
          </MuiGrid>
        </MuiGrid>

        <MuiGrid container justify="center"
          alignItems="center"
          >
          <Link
            to={{
              pathname: routes.addSchool,
              state: {
                isCreateNewSchool: true
              }
            }}
            style={{ textDecoration: 'none' }}
          >
            <MuiButton style={theme.primaryButtonStyle}>
              <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='small' />
              <MuiTypography className={classes.headerTextStyle}>
              {props.i18n.dashBoard.createSchoolProfileButton}</MuiTypography>
            </MuiButton></Link>
        </MuiGrid>
        <MuiGrid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <MuiGrid item xs={12}>
            <MuiTypography style={theme.typography.body}  align='left'>
              <b>{props.i18n.dashBoard.createSchoolProfileNoteTitle}:</b>
            </MuiTypography>
            <MuiTypography style={theme.typography.body}  align='left'>
            {props.i18n.dashBoard.createSchoolProfileNoteDescription} </MuiTypography>
          </MuiGrid>
        </MuiGrid>

      </MuiGrid>
      <MuiGrid
        container
        className={classes.footerStyle}
        xs={12}
        justify="center" >
        <MuiGrid item xs={5} align="center" >
          <MuiButton href={props.i18n.dashBoard.learnMoreRedirectLink} target="_blank">{props.i18n.dashBoard.learnMore}&nbsp;<MuiDoubleArrow color='primary' /></MuiButton>
        </MuiGrid>
        <MuiGrid item xs={7} align="center" >
          <MuiButton href={props.i18n.dashBoard.watchHelpVideoRedirectLink} target="_blank">{props.i18n.dashBoard.watchHelpVideo}&nbsp;<MuiYouTube color='primary' /></MuiButton>
        </MuiGrid>
      </MuiGrid>
    </MuiPaper>
  );
}
